import { Card, Typography, Avatar, useTheme } from '@mui/material'
import useCustomStyles from '../hooks/CustomStylesHook'

const styles = () => ({
  textContainer: {
    flex: 1,
  },
  name: {
    fontWeight: 600,
    fontSize: '17px',
  },
  subtitle: {
    opacity: 0.8,
  },
})

const ProfileSelectionCard = ({
  name,
  role,
  age,
  avatarSrc,
  selected,
  onClick,
  section,
}: {
  name: string
  role: string
  age: number
  avatarSrc: string
  selected: boolean
  onClick: () => void
  section?: React.ReactNode
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const cardStyle = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '20px',
    transition: 'background-color 0.3s, color 0.3s',
    padding: theme.spacing(2),
    cursor: 'pointer',
    backgroundColor: selected
      ? theme.palette.primary.main
      : theme.palette.primary.light,
    color: selected ? theme.palette.common.white : theme.palette.text.primary,
    // minWidth: '260px',
  }

  const avatarStyle = {
    width: 48,
    height: 48,
    marginRight: theme.spacing(2),
    border: selected
      ? `2px solid ${theme.palette.common.white}`
      : `2px solid ${theme.palette.grey[300]}`,
  }

  return (
    <Card style={cardStyle} onClick={onClick} elevation={0}>
      <Avatar src={avatarSrc} style={avatarStyle} />
      <div className={classes?.textContainer}>
        <Typography className={classes?.name}>{name}</Typography>
        <Typography variant='body2' className={classes?.subtitle}>
          {role}, {age} years
        </Typography>
      </div>
      <div>{section}</div>
    </Card>
  )
}

export default ProfileSelectionCard

// // Usage Example
// const App = () => {
//   const [selectedId, setSelectedId] = React.useState(1);

//   const profiles = [
//     {
//       id: 1,
//       name: "Joel Mihavel",
//       role: "Father",
//       age: 40,
//       avatarSrc: "https://via.placeholder.com/48",
//     },
//     {
//       id: 2,
//       name: "Marina",
//       role: "Wife",
//       age: 36,
//       avatarSrc: "https://via.placeholder.com/48",
//     },
//   ];

//   return (
//     <div style={{ display: "flex", gap: "16px" }}>
//       {profiles.map((profile) => (
//         <ProfileCard
//           key={profile.id}
//           {...profile}
//           selected={profile.id === selectedId}
//           onClick={() => setSelectedId(profile.id)}
//         />
//       ))}
//     </div>
//   );
// };

// export default App;
